import { types } from './actions';

const initialState = {
  currentSubmissionId: 0,
  weekOfDate: '',
  userId: 0,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_CURRENT_SUBMISSION_ID: {
      const { currentSubmissionId } = action;
      return {
        ...state,
        currentSubmissionId,
      };
    }
    case types.SET_WEEK_OF_DATE: {
      const { weekOfDate } = action;
      return {
        ...state,
        weekOfDate,
      };
    }
    case types.SET_USER_ID: {
      const { userId } = action;
      return {
        ...state,
        userId,
      };
    }
    default:
      return state;
  }
};

export default reducer;
